import React, { useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  AppBar,
  Tabs,
  Tab,
  Button,
  Typography,
  Badge,
} from '@material-ui/core';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import PersonIcon from '@material-ui/icons/Person';
import { isArray } from 'lodash';

import { UnidataTable } from '~/components';
import CustomizedDialogs from '~/componentsLocal/UnidataDialog';
import { t } from '~/helpers';
import api from '~/services/api';
import { recordFiltering as recordFilteringBico } from '~/store/modules/bico/actions';
import { recordFiltering as recordFilteringUsuario } from '~/store/modules/usuariofrentista/actions';
import { recordFiltering as recordFilteringVeiculo } from '~/store/modules/veiculo/actions';

function DesbloqueioIrregularidadeDbic() {
  const dispatch = useDispatch();

  const [value, setValue] = useState(0);
  const [selected, setSelected] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const reduxBico = useSelector((state) => state.bico);
  const reduxVeiculo = useSelector((state) => state.veiculo);
  const reduxUsuario = useSelector((state) => state.usuariofrentista);

  const headerBico = useMemo(
    () => [
      {
        id: 'idbico',
        label: t('Bico'),
      },
      {
        id: 'codigonomeposto',
        label: t('s.geral.postocomboio'),
      },
      {
        id: 'statusdbic4veiculo',
        label: t('s.configuracao.bico.idterminal'),
      },
    ],
    []
  );

  const headerVeiculo = useMemo(
    () => [
      {
        id: 'idveiculo',
        label: t('Veiculo'),
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.geral.postocomboio'),
      },
      {
        id: 'statusdbic4veiculo',
        label: t('s.configuracao.bico.idterminal'),
      },
    ],
    []
  );

  const headerFrentista = useMemo(
    () => [
      {
        id: 'idusuario',
        label: t('Usuário'),
      },
      {
        id: 'nomeusuario',
        label: t('s.geral.postocomboio'),
      },
      {
        id: 'statususuario',
        label: t('Status'),
      },
    ],
    []
  );
  const endpointObject = {
    0: {
      url: 'bicos',
      msg: 'bico',
      label: 'idbico',
    },
    1: {
      url: 'veiculos',
      msg: 'veiculo',
      label: 'nomempresaveiculo',
    },
    2: {
      url: 'usuariosoperadores',
      msg: 'usuário',
      label: 'nomeusuario',
    },
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelected({});
  };

  const handleModal = () => {
    setOpenModal((prevState) => !prevState);
  };

  const handleConfirmaDesbloqueio = async () => {
    try {
      if (value === 0)
        await api.put(
          `bicos/desbloqueio?idbico=${selected.idbico}&idposto=${selected.idposto}`
        );
      if (value === 1)
        await api.put(`veiculos/desbloqueio?idveiculo=${selected.idveiculo}`);
      if (value === 2)
        await api.put(
          `usuariosfrentistas/desbloqueio?idusuario=${selected.idusuario}`
        );
      toast.success(t('Desbloqueio realizado com sucesso'));
      dispatch(recordFilteringBico(reduxBico.params));
      dispatch(recordFilteringVeiculo(reduxVeiculo.params));
      dispatch(recordFilteringUsuario(reduxUsuario.params));
      handleModal();
    } catch (errors) {
      if (isArray(errors)) errors.map((error) => toast.error(t(error)));
      else toast.error(t(errors));
    }
  };

  return (
    <>
      <AppBar position="static" color="default">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: '10px',
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="off"
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab
              label="Dbic"
              icon={
                <Badge badgeContent={reduxBico.totalCount} color="secondary">
                  <LocalGasStationIcon />
                </Badge>
              }
            />
            <Tab
              label="Veiculo"
              icon={
                <Badge badgeContent={reduxVeiculo.totalCount} color="secondary">
                  <DriveEtaIcon />
                </Badge>
              }
            />
            <Tab
              label="Frentista"
              icon={
                <Badge badgeContent={reduxUsuario.totalCount} color="secondary">
                  <PersonIcon />
                </Badge>
              }
            />
          </Tabs>
          <div>
            <Button
              variant="contained"
              color="primary"
              disabled={Object.keys(selected).length === 0}
              onClick={handleModal}
            >
              Desbloqueio
            </Button>
          </div>
        </div>

        <div role="tabpanel" hidden={value !== 0}>
          <UnidataTable
            id={0}
            fixed
            redux={reduxBico}
            header={headerBico}
            read={recordFilteringBico}
            keys="idbico"
            detach="idbico"
            queryParams={{
              wherefield: 'statusdbic4bico',
              valuewherefield: 0,
              typewherefield: 'EQUALS',
            }}
            onRow={(value) => setSelected(value)}
          />
        </div>
        <div role="tabpanel" hidden={value !== 1}>
          <UnidataTable
            id={0}
            fixed
            redux={reduxVeiculo}
            header={headerVeiculo}
            read={recordFilteringVeiculo}
            keys="idveiculo"
            detach="idveiculo"
            queryParams={{
              wherefield: 'statusdbic4veiculo',
              valuewherefield: 0,
              typewherefield: 'EQUALS',
            }}
            onRow={(value) => setSelected(value)}
          />
        </div>
        <div role="tabpanel" hidden={value !== 2}>
          <UnidataTable
            id={2}
            fixed
            redux={reduxUsuario}
            header={headerFrentista}
            read={recordFilteringUsuario}
            keys="idusuario"
            detach="idusuario"
            queryParams={{
              wherefield: 'statusdbic4usuariooperador',
              valuewherefield: 0,
              typewherefield: 'EQUALS',
            }}
            onRow={(value) => setSelected(value)}
          />
        </div>
      </AppBar>
      <CustomizedDialogs
        open={openModal}
        handleClose={handleModal}
        children={
          <Typography>
            Deseja desbloquear o {endpointObject[value].msg}{' '}
            {selected[endpointObject[value].label]}?
          </Typography>
        }
        actions={
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleConfirmaDesbloqueio();
              }}
            >
              Sim
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                handleModal();
              }}
            >
              Não
            </Button>
          </>
        }
      />
    </>
  );
}

export default DesbloqueioIrregularidadeDbic;
